export default __webpack_public_path__ + "static/media/pinbidjaxxx-color.890187dd.svg";